module.exports = __webpack_public_path__ + "img/buy-notPay.78cc9dce.png";